(function () {
  'use strict';

  angular.module('wsLrs.services').factory("PersonUtils", ['$q', 'User', 'Api', '$http', 'TinCanJS', 'Utils', 'Logger', function ($q, User, Api, $http, TinCanJS, Utils, Logger) {
    return {
      //returns a promise
      getUserPersonId: function getUserPersonId() {
        return this.getPerson().then(function (person) {
          return person.id;
        });
      },
      getPerson: function getPerson(user) {
        if (!user) {
          user = User.get().user;
        }
        var peopleUrl = Api.url('/people'),
          deferredPersonId = $q.defer(),
          persona = TinCanJS.getUserPersona(user);
        $http.get(peopleUrl + "/with-persona", {
          "params": {
            "persona": persona
          }
        }).then(function (response) {
          // Found person, just return the found ID...
          deferredPersonId.resolve(response.data);
        }, function (response) {
          // Only a 404 is expected here... Otherwise, reject promise and bail out
          if (response.status !== 404) {
            var err = "Error fetching person object for user " + user.id + ". " + "Status code = " + response.status;
            Logger.error(err);
            deferredPersonId.reject(err);
            return;
          }

          // Alright, didn't find the person, let's create one for this user persona
          var personData = {
            "name": user.name,
            "personas": [persona]
          };
          $http.post(peopleUrl, personData).then(function (response) {
            // Created, grab person ID from created response...
            deferredPersonId.resolve(parseInt(Utils.getIdFromCreatedResponse(response)));
          }, function (response) {
            var err = "Error creating person object for user " + user.id + ". " + "Status code = " + response.status;
            Logger.error(err);
            deferredPersonId.reject(err);
          });
        });
        return deferredPersonId.promise;
      }
    };
  }]);
})();
